import { createSelector } from 'reselect';
import { ALL_ORGS_CONTEXT } from '../../constants/admin/settings';
import { find } from 'lodash';
import { hasPermissions, hasViewAllPermission, PERMISSIONS } from '../../constants/authentication/permissions';

// STATE SELECTORS
const contextSubject = state => state.admin.context.subject;
const options = state => state.admin.context.options;
const context = state => state.admin.context;
const user = state => state.authentication.user;

export const contextSubjectSelector = createSelector(contextSubject, cs => cs);
export const hasContextSelector = createSelector(contextSubject, cs => !!cs);
export const contextReadySelector = createSelector(context, c => c.ready);
export const contextOptionsSelector = createSelector(options, user, (options, user) => {
    return (
        hasPermissions(user, PERMISSIONS.GOD) || hasViewAllPermission(user)
            ? [{ label: ALL_ORGS_CONTEXT.name, value: ALL_ORGS_CONTEXT.id }]
            : []
    ).concat(_orgsAsOptions(options));
});
export const organizationsOptionsSelector = createSelector(options, options => _orgsAsOptions(options || []));
export const contextNameSelector = createSelector(contextOptionsSelector, contextSubject, (o, s) => {
    const context = find(o, i => i.value === s);
    return (context && context.label) || '';
});

// DATA SELECTORS
export const organizationsAsOptions = (organizations = []) =>
    organizations.map(o => ({
        id: o.id,
        name: o.name
    }));

const _orgsAsOptions = options => options.map(o => ({ label: o.name, value: o.id }));
